(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gallery"] && !Shopify.designMode) return;
  try {
    
 $('.gallery-pop').magnificPopup({
      type: 'image',
      closeOnContentClick: true,
      mainClass: 'mfp-img-mobile',
      image: {
        verticalFit: true
      }

    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-vertical-mega-menu"]) return;
  try {
    
$("#init-toggle").click(function(){
    $(this).toggleClass('open');
    $(".vertical-mega-menu").toggleClass('open');    
  });

  jQuery(document).ready(function($) {  
   "use strict";    
     
       if($(window).width() <= 991) { 
      
      $("nav.vertical-mega-menu").each(function() {
  
        var vdata = $(this).data('vmenu'),                    
            ulData = $(this).find('ul[data-vmenu="' + vdata + '"]').clone().removeClass('dt-vnav'),
            vmobileData = $('body').find('.mobile-vmenu[data-vmenu="' + vdata + '"]');        

        console.log(ulData);
        // To Remove animation classes
        $('[data-animation]', ulData).each(function(ix, ele) {
          var $classes = $(ele).attr("class"),
              $animation = $(ele).attr("data-animation");
          $classes = $classes.replace($animation, '');
          $(ele).attr("class", $classes);
        });  
        ulData.prependTo(vmobileData);
      });
  
      VmobileTrigger();
  
      // Closing Mobile Nav
      $('li.v-close-nav').on('click', function(event) {
        VcloseMobNav();
      });
  
      $('body .vertical-mobile-menu-overlay').on('click', function(event) {
        VcloseMobNav();
      });
  
      // Sub Menu in Mobile Menu
      $('.v-mega-has-children > a').on('click', function(event) {
  
        if ($('body').hasClass('vnav-is-visible')) {
          event.preventDefault();
          var a = $(this).clone();
          $(this).next('.v-menu-sub').find('.see-all').html(a);          
        }
  
        var selected = $(this);                
        if (selected.next('div.v-menu-sub').hasClass('is-v-hidden')) {                    
          selected.addClass('selected').next('div.v-menu-sub').removeClass('is-v-hidden');
        } else {          
          selected.removeClass('selected').next('div.v-menu-sub').addClass('is-v-hidden');
        }
      });
  
      // Go Back in Mobile Menu
      $('.go-back').on('click', function() {        
        $(this).closest('div.v-menu-sub').addClass('is-v-hidden');
      });
    }
  

   function VmobileTrigger(){
      $('.vmenu-trigger').on('click', function(event) {    
        $('body').find('.mobile-vmenu').addClass('vnav-is-visible');
        $('body').find('.mobile-menu-overlay').addClass('is-showit');
        $('body').addClass('vnav-is-visible');        
      });  
    }
  
    function VcloseMobNav() {
      $('body').removeClass('vnav-is-visible');
      $('.vertical-mobile-menu-overlay').removeClass('is-showit');
      $('.mobile-vmenu').removeClass('vnav-is-visible');
      $('.v-mega-has-children a').removeClass('selected');
      $('.v-mega-has-children div.v-menu-sub').addClass('is-v-hidden');
    }
  
    $(window).on('resize',function() {
      VmobileTrigger();
      VcloseMobNav();          
    });
  
    $(window).on('load',function() {     
      VmobileTrigger();
      VcloseMobNav();  
    });

/* Tabs on Vertical navigation  */
    
 $(function() {
      if($(window).width() >= 992) {
         $('.from-vertical .tabs-nav a').click(function() {
         $(this).removeClass('active');
        $(this).parent().addClass('active');  
        let currentTab = $(this).attr('href');        
        $('.v-menu-sub .tabs-content li.dt-sc-menu-tabs').hide();
       console.log(currentTab);
        $(currentTab).show();
        return false;
      });
    }
      if($(window).width() < 992 ) { 
      $('.from-vertical .mobileTabs .tabs  li').each(function(){
        $(this).click(function(){        
          $(this).next('div').slideToggle(0);        
        });  
      })  
    }
    });    
});
  


  
  $('.level-has-child li.leavel-has-dropdown').click(function () {  
          $('li.leavel-has-dropdown').not(this).find('ul').hide();  
          $(this).find('ul').toggle();  
      });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tamim-footer"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (customElements.get('dtf-cols')) return;
  class DtfCols extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.mql = window.matchMedia('(max-width: 640px)');
      this.onChange = function () { self.apply(); };
      if (this.mql.addEventListener) this.mql.addEventListener('change', this.onChange);
      else if (this.mql.addListener) this.mql.addListener(this.onChange);
      this.addEventListener('click', function (e) {
        var s = e.target.closest && e.target.closest('summary');
        if (!s) return;
        if (!(self.mql.matches && self.getAttribute('data-mode') === 'accordion')) e.preventDefault();
      });
      this.apply();
    }
    disconnectedCallback() {
      if (!this.mql) return;
      if (this.mql.removeEventListener) this.mql.removeEventListener('change', this.onChange);
      else if (this.mql.removeListener) this.mql.removeListener(this.onChange);
    }
    apply() {
      var acc = this.mql.matches && this.getAttribute('data-mode') === 'accordion';
      this.querySelectorAll('details.dtf-acc').forEach(function (d) { d.open = !acc; });
    }
  }
  customElements.define('dtf-cols', DtfCols);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tamim-picks"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__dtpReady) return;
  window.__dtpReady = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- toast ---------- */
  var toastEl, toastTimer;
  function toast(text, linkText, linkHref) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'dtp-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = '';
    var span = document.createElement('span');
    span.textContent = text;
    toastEl.appendChild(span);
    if (linkText && linkHref) {
      var a = document.createElement('a');
      a.href = linkHref;
      a.textContent = linkText;
      toastEl.appendChild(a);
    }
    toastEl.dir = document.documentElement.dir || 'rtl';
    void toastEl.offsetWidth;
    toastEl.classList.add('is-in');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-in'); }, 3800);
  }

  /* ---------- cart ---------- */
  function updateCartUI(cart, root) {
    var sel = (root && root.getAttribute('data-count-selector')) || '';
    if (sel) {
      try {
        document.querySelectorAll(sel).forEach(function (el) { el.textContent = cart.item_count; el.removeAttribute('hidden'); });
      } catch (e) {}
    }
    ['cart:updated', 'cart:refresh', 'cart:change'].forEach(function (name) {
      document.dispatchEvent(new CustomEvent(name, { detail: { cart: cart } }));
    });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('[data-dtp-form]')) return;
    e.preventDefault();
    var root = form.closest('.dtp');
    var btn = form.querySelector('button[type="submit"]');
    var label = btn.querySelector('.dtp-btn__label');
    if (btn.getAttribute('aria-busy') === 'true') return;
    var old = label.textContent;
    btn.setAttribute('aria-busy', 'true');
    btn.disabled = true;
    label.textContent = root.getAttribute('data-msg-adding');
    var restore = function () { btn.removeAttribute('aria-busy'); btn.disabled = false; label.textContent = old; };
    fetch(root.getAttribute('data-cart-add-url') + '.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error((res.d && (res.d.description || res.d.message)) || '');
        return fetch(root.getAttribute('data-cart-url') + '.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        updateCartUI(cart, root);
        var after = root.getAttribute('data-after');
        if (after === 'cart') { window.location.href = root.getAttribute('data-cart-url'); return; }
        label.textContent = root.getAttribute('data-msg-added');
        if (after === 'toast') toast(root.getAttribute('data-msg-added'), root.getAttribute('data-msg-view-cart'), root.getAttribute('data-cart-url'));
        setTimeout(restore, 1600);
      })
      .catch(function (err) {
        restore();
        toast((err && err.message) || root.getAttribute('data-msg-error'));
      });
  });

  /* ---------- wishlist (stored in the visitor's browser) ---------- */
 /* ---------- wishlist: shared with the theme ---------- */
var KEY = 'shopify-wishlist';

function readWL() {
  try {
    return [...new Set(
      (localStorage.getItem(KEY) || '')
        .split(',')
        .filter(Boolean)
    )];
  } catch (e) {
    return [];
  }
}

function writeWL(list) {
  if (list.length) {
    localStorage.setItem(KEY, list.join(','));
  } else {
    localStorage.removeItem(KEY);
  }
}

function syncWL() {
  var list = readWL();

  document.querySelectorAll('[data-dtp-wish]').forEach(function (b) {
    var added = list.indexOf(b.getAttribute('data-dtp-wish')) !== -1;
    b.setAttribute('aria-pressed', added ? 'true' : 'false');
  });

  document.querySelectorAll('.dt-wishlist-cnt').forEach(function (el) {
    el.textContent = list.length;
    el.setAttribute('count', list.length);
    el.classList.toggle('hidden', list.length === 0);
  });

  document.querySelectorAll(
    'dtx-wishlist .add-wishlist[data-product_handle]'
  ).forEach(function (b) {
    var handle = b.getAttribute('data-product_handle');
    b.classList.toggle('added', list.indexOf(handle) !== -1);
  });
}

document.addEventListener('click', function (e) {
  var b = e.target.closest && e.target.closest('[data-dtp-wish]');
  if (!b) return;

  e.preventDefault();

  var root = b.closest('.dtp');
  var handle = b.getAttribute('data-dtp-wish');
  if (!root || !handle) return;

  var list = readWL();
  var index = list.indexOf(handle);
  var added = index === -1;

  if (added) {
    list.push(handle);
  } else {
    list.splice(index, 1);
  }

  try {
    writeWL(list);
  } catch (err) {
    toast('تعذّر حفظ المفضلة في المتصفح. حاول مرة أخرى.');
    return;
  }

  syncWL();

  document.dispatchEvent(new CustomEvent('dtp:wishlist', {
    detail: { handle: handle, added: added, list: list }
  }));

  var url = root.getAttribute('data-wish-url');
  toast(
    root.getAttribute(
      added ? 'data-msg-wish-add' : 'data-msg-wish-remove'
    ),
    added && url ? root.getAttribute('data-msg-view-wish') : '',
    url
  );
});

/* The theme's normal button saves after a debounce. */
document.addEventListener('click', function (e) {
  var originalButton = e.target.closest &&
    e.target.closest('dtx-wishlist .add-wishlist');

  if (originalButton) setTimeout(syncWL, 1100);
});

window.addEventListener('storage', function (e) {
  if (e.key === KEY || e.key === null) syncWL();
});

window.addEventListener('pageshow', syncWL);
syncWL();


  /* ---------- carousel ---------- */
  class DtpCarousel extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('.dtp');
      this.track = this.querySelector('[data-dtp-track]');
      this.prev = this.querySelector('[data-dtp-prev]');
      this.next = this.querySelector('[data-dtp-next]');
      this.dots = this.querySelector('[data-dtp-dots]');
      if (!this.track) return;
      var rtl = getComputedStyle(this.track).direction === 'rtl';
      this.sign = rtl ? -1 : 1;
      if (this.root && !this.root.getAttribute('data-dir')) this.root.setAttribute('data-dir', rtl ? 'rtl' : 'ltr');
      this.pages = 0;
      this._raf = 0;
      var self = this;
      this._onScroll = function () { if (self._raf) return; self._raf = requestAnimationFrame(function () { self._raf = 0; self.update(); }); };
      this.track.addEventListener('scroll', this._onScroll, { passive: true });
      if (this.prev) this.prev.addEventListener('click', function () { self.go(-1); });
      if (this.next) this.next.addEventListener('click', function () { self.go(1); });
      this._ro = new ResizeObserver(function () { self.measure(); });
      this._ro.observe(this.track);
      this.measure();
      syncWL();
      this.setupAutoplay();
    }
    disconnectedCallback() {
      if (this._ro) this._ro.disconnect();
      if (this.track && this._onScroll) this.track.removeEventListener('scroll', this._onScroll);
      this.stopAutoplay();
    }
    metrics() {
      var items = this.track.children, first = items[0];
      var gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      var w = first ? first.getBoundingClientRect().width : 0;
      var step = w + gap || 1;
      var vis = Math.max(1, Math.floor((this.track.clientWidth + gap) / step + 0.05));
      var max = this.track.scrollWidth - this.track.clientWidth;
      return { n: items.length, step: step, vis: vis, max: max };
    }
    measure() {
      var m = this.metrics();
      var pages = m.max > 2 ? Math.max(1, Math.ceil(m.n / m.vis)) : 1;
      if (pages !== this.pages) { this.pages = pages; this.buildDots(); }
      var multi = pages > 1;
      var always = this.getAttribute('data-arrows-always') === '1';
      if (this.prev) this.prev.hidden = !multi && !always;
      if (this.next) this.next.hidden = !multi && !always;
      if (this.dots) this.dots.hidden = !multi;
      this.update();
    }
    buildDots() {
      if (!this.dots) return;
      var label = this.getAttribute('data-dot-label') || '';
      var self = this;
      this.dots.textContent = '';
      for (var i = 0; i < this.pages; i++) {
        (function (i) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'dtp__dot';
          b.setAttribute('aria-label', label + ' ' + (i + 1));
          b.addEventListener('click', function () { self.goPage(i); });
          self.dots.appendChild(b);
        })(i);
      }
    }
    update() {
      var m = this.metrics(), pos = Math.abs(this.track.scrollLeft);
      if (this.prev) this.prev.disabled = pos <= 2;
      if (this.next) this.next.disabled = pos >= m.max - 2;
      if (!this.dots || !this.pages) return;
      var idx = pos >= m.max - 2 ? this.pages - 1 : Math.min(this.pages - 1, Math.round(pos / (m.vis * m.step)));
      var kids = this.dots.children;
      for (var i = 0; i < kids.length; i++) kids[i].setAttribute('aria-current', i === idx ? 'true' : 'false');
    }
    scrollToPos(pos) {
      var m = this.metrics();
      pos = Math.max(0, Math.min(m.max, pos));
      this.track.scrollTo({ left: this.sign * pos, behavior: reduce ? 'auto' : 'smooth' });
    }
    go(dir) {
      var m = this.metrics();
      this.scrollToPos(Math.abs(this.track.scrollLeft) + dir * m.vis * m.step);
    }
    goPage(i) {
      var m = this.metrics();
      this.scrollToPos(i * m.vis * m.step);
    }
    setupAutoplay() {
      var secs = parseInt(this.getAttribute('data-autoplay'), 10);
      if (!secs || reduce) return;
      var self = this, paused = false;
      var pause = function () { paused = true; }, resume = function () { paused = false; };
      ['mouseenter', 'focusin', 'touchstart'].forEach(function (ev) { self.addEventListener(ev, pause, { passive: true }); });
      ['mouseleave', 'focusout', 'touchend'].forEach(function (ev) { self.addEventListener(ev, resume, { passive: true }); });
      this._timer = setInterval(function () {
        if (paused || document.hidden || self.pages < 2) return;
        var m = self.metrics(), pos = Math.abs(self.track.scrollLeft);
        if (pos >= m.max - 2) self.scrollToPos(0); else self.go(1);
      }, secs * 1000);
    }
    stopAutoplay() { if (this._timer) { clearInterval(this._timer); this._timer = null; } }
  }
  if (!customElements.get('dtp-carousel')) customElements.define('dtp-carousel', DtpCarousel);
})();

  } catch(e) { console.error(e); }
})();
})();
